// Phone mask utility for Brazilian phone numbers
export const maskPhone = (value) => {
  if (!value) return '';

  // Remove all non-numeric characters
  const cleaned = value.replace(/\D/g, '');

  // Apply mask progressively
  let masked = cleaned;

  if (cleaned.length <= 2) {
    masked = cleaned.replace(/^(\d{0,2})/, '($1');
  } else if (cleaned.length <= 6) {
    masked = cleaned.replace(/^(\d{2})(\d{0,4})/, '($1) $2');
  } else if (cleaned.length <= 10) {
    masked = cleaned.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3');
  } else {
    masked = cleaned.replace(/^(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3');
  }

  return masked;
};

// Remove mask from phone number
export const unmaskPhone = (value) => {
  if (!value) return '';
  return value.replace(/\D/g, '');
};

export default {
  maskPhone,
  unmaskPhone
};